
				var addMethods = require("../../../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["CustomCSSWorker"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "4f866ac8aafa068bd42f.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			